import './ActivityTextBox.css'

import React from 'react'
import { ActivityStatus } from '@/pages/communal/statistics/components/common/data'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { TimeDHM } from '@/components/Elements/time'
import { secondsToDHM } from '@/common/time'

type ActivityStatusBoxProps = {
  services: Services
  session: CurrentSession
  activityStatus: ActivityStatus
}

export const ActivityTextBox = ({ services, session, activityStatus, }: ActivityStatusBoxProps) => {
  const translates = useTranslations(services, session)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <div className="communal-userstatistic-activitytext-box">
    <div className="activitytext-stat">
      <h3 className="activitytext-title">
        {translates.for('page.statistics.global.box.activitytext.active')}
      </h3>
      <span className="activitytext-value">
        <TimeDHM dhm={secondsToDHM(activityStatus.activeTime)} translates={translates} />
      </span>
    </div>
    <div className="activitytext-stat">
      <h3 className="activitytext-title">
        {translates.for('page.statistics.global.box.activitytext.onfire')}
      </h3>
      <span className="activitytext-value">
        <TimeDHM dhm={secondsToDHM(activityStatus.onFireTime)} translates={translates} />
      </span>
    </div>
  </div>
}